/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tl_Unscheduled_EmptyInputs */

const en_tl_unscheduled_empty = /** @type {(inputs: Tl_Unscheduled_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Everything in this view has dates.`)
};

const de_tl_unscheduled_empty = /** @type {(inputs: Tl_Unscheduled_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alles in dieser Ansicht hat Termine.`)
};

/**
* | output |
* | --- |
* | "Everything in this view has dates." |
*
* @param {Tl_Unscheduled_EmptyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tl_unscheduled_empty = /** @type {((inputs?: Tl_Unscheduled_EmptyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tl_Unscheduled_EmptyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_tl_unscheduled_empty(inputs)
	return en_tl_unscheduled_empty(inputs)
});